module.exports = __webpack_public_path__ + "assets/img/logo.301d4d4e.svg";